import Immutable from 'seamless-immutable';
import _ from 'lodash';
import refData from '../../../resources/ref-data/fe-ref-data.json';
import { logger } from '../common/Services';

/**
 * RefData
 * @typedef {Object} RefData
 * @property {string} id - the ref data id (e.g. "category.scope.code")
 * @property {string} category - the ref data's category poriton of the id
 * @property {?string} scope - the ref data's scope portion of the id, used for filtering. Can be multiple period delineated segments
 * @property {string} code - the ref data's code portion of the id, can be multiple period delineated segments
 * @property {string} name - the public facing name
 * @property {boolean} isEnabled - whether the ref data is enabled or not
 * additional properties that are unique to this particular ref data item, ref data items of the same "category.scope" should have the same custom properties
 */

const _refDataById = _deserialize(refData);

/**
 * Create a RefData from provided data
 */
function create(data = {}) {
  return Immutable(data, { prototype: model });
}

/**
 * Takes a ref data ID and returns a fully hyrdated RefDataModel
 * @param {string} id - the id of any ref data
 * @returns {RefData}
 */
function hydrate(id) {
  const refData = _refDataById[id];
  logger.error(`Hydrate ref data error. Unknown ref data id: ${id}`, !refData);
  return create(refData);
}

const model = {
  tokenize() {
    return this.id.split('.');
  },
};

function _validate(datum) {
  logger.error(`Ref datum missing "category" error: ${datum.id}`, !datum.category);
  logger.error(`Ref datum missing "code" error: ${datum.id}`, !datum.code);
  logger.error(`Ref datum missing "name" error: ${datum.id}`, !datum.name);
  logger.error(
    `Ref datum tokenization error, id must be composed of "category.scope.code": ${datum.id} ${datum.category} ${
      datum.scope
    } ${datum.code}`,
    datum.id.replace(/\./g, '') !== [datum.category, datum.scope, datum.code].join('').replace(/\./g, '')
  );
  logger.error(
    `Ref datum casing error, only lower case letters allowed in the id: ${datum.id}`,
    /[A-Z]/.test(datum.id)
  );
}

/**
 * filter out disabled ref data
 * rename snake_case properties to camelCase
 */
function _deserialize(refData) {
  return _.reduce(
    _.pickBy(refData, datum => datum.is_enabled),
    (acc, datum, key) => {
      // _validate(datum); //TODO turn back on once data is cleaned up
      acc[key] = datum;
      Object.assign(acc[key], datum.custom_attributes);
      delete acc[key].LEGACY_DO_NOT_COPY; // Field for legacy values to support backwards compatibility (BE only)
      delete acc[key].custom_attributes;
      acc[key].isEnabled = datum.is_enabled;
      delete acc[key].is_enabled;
      acc[key].id = key;
      return acc;
    },
    {}
  );
}

export default {
  create,
  hydrate,
};
